<template>
  <div class="nave-viaje-width">
    <ui-modal
      ref="modal"
      @close="actionSetVisibleModalCambiarServicioConfirmadoBooking(false), ActionSetZindexTablaModal(false)"
      :title="`Modificar itinerario - Cliente: ${clienteModel}`"
    >
      <!-- Contenedor superior -->
      <div v-if="load">
        <loading />
      </div>
      <div v-else class="w-100 text-center">
        <fieldset-component texto="Booking seleccionado" class="mb-2" bold />

          <div class="d-flex flex-column">
            <!-- Tabla -->
            <div class="d-flex">
              <div class="w-20">
                <div class="Heading Cell">
                  <p class="m-2">Semana</p>
                </div>
                <div class="d-flex justify-content-center Cell Altura">
                  <p class="m-2" v-text="semanaModel"></p>
                </div>
              </div>
              <div class="w-25">
                <div class="Heading Cell">
                  <p class="m-2">Cliente</p>
                </div>
                <div class="d-flex justify-content-center Cell Altura">
                  <p class="m-2" v-text="clienteModel"></p>
                </div>
              </div>
              <div class="w-25">
                <div class="Heading Cell">
                  <p class="m-2">POL</p>
                </div>
                <div class="d-flex justify-content-center Cell Altura">
                  <p class="m-2" v-text="polModel"></p>
                </div>
              </div>
              <div class="w-25">
                <div class="Heading Cell">
                  <p class="m-2">POD</p>
                </div>
                <div class="d-flex justify-content-center Cell Altura">
                  <p class="m-2" v-text="podModel"></p>
                </div>
              </div>
              <div class="w-25">
                <div class="Heading Cell">
                  <p class="m-2">Cantidad</p>
                </div>
                <div class="d-flex justify-content-center Cell Altura">
                  <p class="m-2" v-text="cantidadModel"></p>
                </div>
              </div>
              <div class="w-25">
                <div class="Heading Cell">
                  <p class="m-2">Producto</p>
                </div>
                <div class="d-flex justify-content-center Cell Altura">
                  <p class="m-2" v-text="productoModel"></p>
                </div>
              </div>
             
              <div class="w-50">
                <div class="Heading Cell">
                  <p class="m-2">Nave</p>
                </div>
                <div class="d-flex justify-content: center; Cell Altura">
                  <p class="m-2" v-text="nave"></p>
                </div>
              </div>

              <div class="w-50">
                <div class="Heading Cell">
                  <p class="m-2">Viaje</p>
                </div>
                <div class="d-flex justify-content: center; Cell Altura">
                  <p class="m-2" v-text="viaje"></p>
                </div>
              </div>

              <div class="w-50">
                <div class="Heading Cell">
                  <p class="m-2">Comentarios</p>
                </div>
                <div class="d-flex justify-content: center; Cell Altura">
                  <p class="m-2" v-text="comentariosModel"></p>
                </div>
              </div>
              
            </div>
          </div>

          <!-- Contenedor inferior -->
          <fieldset-component texto="Elegir Servicio" class="mb-1 mt-4" bold />

          <data-table-booking-cambiar-servicio
            class="mt-2"
            :cantidadMin="cantidadMin"
            :dataBKN="null"
            :id="booking_id"
            :booking_itinerary_id="booking_itinerary_id"
            :changeService="true"
            :redirect="redirect"

          />
        
      </div>
      
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapState } from "vuex";

//Componentes
import FieldsetComponent from "../../../../common/FieldsetComponent";
import DataTableBookingCambiarServicio from "../../../../../components/modals/lineas/booking/bookings_confirmados/DataTableBookingCambiarServicio";

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import Loading from "../../../../common/loading";
import { verBookingItineraries } from "../../../../../constants/lineas";

export default {
  props: ["form","load"],
  data() {
    return {
      numeroBookingModel: "",
      semanaModel: "",
      clienteModel: "",
      polModel: "",
      podModel: "",
      cantidadModel: "",
      productoModel: "",
      comentariosModel: "",
      nave: "",
      viaje: "",
      booking_id: null,
      booking_itinerary_id : null,
      cantidadMin: 0,
      
    };
  },
  components: {
    UiModal,
    FieldsetComponent,
    Loading,
    DataTableBookingCambiarServicio
  },
  computed: {
    ...mapState(["puertos", "loadingServiciosBooking"]),
    ...mapState("lineas", ["visibleModalCambiarServicioConfirmadoBooking"]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetVisibleModalCambiarServicioConfirmadoBooking",
      "actionSetIdAuxiliarBookingSeleccionado",
    ]),

    ...mapActions(["ActionSetLoadingTable","ActionSetZindexTablaModal"]),

    openModal(ref) {
      this.$refs[ref].open();
      this.ActionSetZindexTablaModal(true);
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
    closeModalAction() {
      this.actionSetVisibleModalCambiarServicioConfirmadoBooking(false); 
      this.closeModal("modal");
    },
    redirect(){
      this.actionSetVisibleModalCambiarServicioConfirmadoBooking(false); 
    },
    async setData(form) {

      const data = await verBookingItineraries(form);

      this.semanaModel = data.semana;
      this.clienteModel = data.cliente;
      this.polModel = data.pol;
      this.podModel = data.pod;
      this.cantidadModel = data.cantidad_bi;
      this.productoModel = data.producto;
      this.comentariosModel = data.comentarios;
      this.nave = data.nave;
      this.viaje = data.viaje;
      this.booking_itinerary_id = data.booking_itinerary_id;
      this.booking_id = data.booking_id;
      this.cantidadMin = +data.cantidad_bi;

    }
  },

  watch: {
    visibleModalCambiarServicioConfirmadoBooking: function (_new) {
      _new 
        ? this.openModal("modal")
        : this.closeModal("modal") ;
    },
    form: function(_new){
      
      if ( _new ) this.setData( _new );
      
    }
  },
};
</script>

<style scoped>
#estiloModal .modal-aceptar-booking-declarado .ui-modal__container {
  width: 50% !important;
  margin-top: 10px !important;
}

#estiloModal .Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
}

#estiloModal .Cell {
  border: groove;
  border-width: thin;
}
#estiloModal .Altura {
  height: 60px;
}
#estiloModal .form-control.input-sm {
  height: 30px !important;
  min-width: auto !important;
}

#estiloModal .flex-column {
  font-size: 11px ;
}
</style>
